import * as React from "react";
import "./buttonGroup.scss";

interface IProps {
	/**
	 * Custom class name.
	 */
	customClass?: string;
}

const ButtonGroup: React.SFC<IProps> = (props) => {
	return (
		<div className={`a-button-group ${props.customClass ? props.customClass : ""}`}>
			{props.children}
		</div>
	);
};

export default ButtonGroup;
